import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import withFetchDataLoader from '../../../common/hoc/withFetchDataLoader';
import PayoutsReport from './components/WithCommissionSplits';
import { fetchPayoutsReport, fetchLastPayoutDate, processPayout, fetchPayoutsHistory } from '../actions';
import {
  getPayoutReportServiceItems,
  getPayoutReportFromDate,
  getPayoutReportToDate,
  getPayoutReportLastPayout,
  getPayoutReportProductItems,
  getIsAutoDeposit,
  getTotalAvailableForPayout,
  getGiftCardTipsTransfered,
} from '../selectors';
import * as authSelectors from '../../../auth/selectors';
import { updateShop } from '../../shops/actions';
import BarberPayoutReport from '../../../barber/reports/payout/containers/ReportContainer';

const fetchData = withHandlers({
  fetchData: (props) => () => {
    const shopId = props.isSingleShopOtpBrand ? props.brandSingleShopId : props.shopId;

    return Promise.all([
      props.fetchPayoutsReport(shopId),
      props.fetchLastPayoutDate(shopId),
      props.fetchPayoutsHistory(shopId),
    ]);
  },
});

const processAction = compose(
  withState('processing', 'setProcessing', false),
  withHandlers({
    processPayout: (props) => () => {
      props.setProcessing(true);
      return props
        .processPayout(props.shopId)
        .then(() => props.fetchData(props.shopId))
        .then(() => props.setProcessing(false));
    },
    toggleAutoDeposit: (props) =>
      debounce(async (enabled) => {
        await props.updateShop(props.shopId, { commissionSplitsAutoDeposit: enabled });
        return true;
      }, 300),
  })
);

const mapStateToProps = (state) => ({
  shopId: authSelectors.getShop(state),
  isSingleShopOtpBrand: authSelectors.isSingleShopOtpBrand(state),
  brandSingleShopId: authSelectors.getBrandSingleShopId(state),
  activeType: authSelectors.getActiveType(state),
  autoDepositChecked: getIsAutoDeposit(state),
  serviceItems: getPayoutReportServiceItems(state),
  productItems: getPayoutReportProductItems(state),
  fromDate: getPayoutReportFromDate(state),
  toDate: getPayoutReportToDate(state),
  lastTransferDate: getPayoutReportLastPayout(state),
  totalAvailableForPayout: getTotalAvailableForPayout(state),
  giftCardTipsAmount: getGiftCardTipsTransfered(state),
});
const mapDispatchToProps = {
  fetchPayoutsReport,
  fetchLastPayoutDate,
  processPayout,
  fetchPayoutsHistory,
  updateShop,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch((props) => props.activeType === 'barber', renderComponent(BarberPayoutReport)),
  fetchData,
  processAction,
  withFetchDataLoader
)(PayoutsReport);
